const SvgAdd = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="M31.429 15.143H.572v1.714h30.857zM16.857 31.429V.572h-1.714v30.857z" />
  </svg>;
export default SvgAdd;